import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountServiceProvider } from '@services/user/account.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { User } from '@models/models';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import { Brands } from '@models/brands.model';

@Component({
	selector: 'user-navbar',
	template: require('./user-navbar.component.html'),
	styles: [require('./user-navbar.component.scss')]
})
export class UserNavbarComponent implements OnInit, OnDestroy {
	user: User;
	brands: Brands;
	showLogo = false;
	private unsubscribe: Subject<void> = new Subject();
	isSwitchBrandSpinnerActive = false;

	constructor(
		private accountService: AccountServiceProvider,
		private brandsDataService: BrandsDataServiceProvider
	) {}

	ngOnInit(): void {
		this.getUser();
		this.trackLogoState();
		this.getBrandsInfo();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	logout(): void {
		this.accountService.logoutWeb();
	}

	handleSwitchBrandSpinner(event: boolean): void {
		this.isSwitchBrandSpinnerActive = event;
		event
			? document.body.classList.add('disable-scroll')
			: document.body.classList.remove('disable-scroll');
	}

	getClass(path) {
		let locationPath = location.pathname;

		if (locationPath.includes('/invoices')) {
			locationPath = '/payments';
		}

		if (path === '/') {
			if (
				locationPath.substring(
					0,
					location.protocol.length + location.host.length
				) === path
			) {
				return 'selected-menu';
			}
			return 'not-selected-menu';
		}
		if (locationPath.includes(path)) {
			return 'selected-menu';
		}
		return 'not-selected-menu';
	}

	private getUser(): void {
		this.accountService.userDataObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((user: User): void => {
				this.user = user;
			});
	}

	private trackLogoState(): void {
		this.accountService.showHeaderObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((state: boolean): boolean => (this.showLogo = state));
	}

	private getBrandsInfo(): void {
		this.brandsDataService.brandsData
			.pipe(
				takeUntil(this.unsubscribe),
				filter((data: Brands) => data !== null)
			)
			.subscribe((data: Brands): void => {
				this.brands = data;
			});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/navbar/user-navbar/user-navbar.component.ts